import React from 'react'
import Chart from "react-apexcharts";

const TestCaseTypeChart = ({ categories = [], chartSeries = [] }) => {
    const series = [
        {
            name: "Count",
            data: chartSeries,
        },
    ];

    const options = {
        chart: {
            type: "bar",
            toolbar: { show: false },
        },
        plotOptions: {
            bar: {
                horizontal: false,
                columnWidth: "45%",
                borderRadius: 6,
            },
        },
        dataLabels: {
            enabled: true,
            style: {
                colors: ["#fff"],
            },
        },
        colors: ["#008FFB"],
        xaxis: {
            categories: categories,
            labels: {
                rotate: -45,
                style: {
                    fontSize: "12px",
                    colors: "#555",
                },
                offsetY: 0, // 🔹 keeps labels closer to the bottom
            },
        },
        yaxis: {
            title: {
                text: "Count",
                style: {
                    fontSize: "12px",
                    fontWeight: "bold",
                },
            },
            labels: {
                style: {
                    fontSize: "8px",
                    colors: "#555",
                },
            },
        },
        grid: {
            borderColor: "#e7e7e7",
            strokeDashArray: 3,
            padding: {
                bottom: -10, // 🔹 reduces the extra bottom space
            },
        },
        title: {
            text: "Test Case Type Count",
            align: "left",
            style: {
                fontSize: "16px",
                fontWeight: "bold",
            },
        },
        tooltip: {
            y: {
                formatter: (val) => `${val} tests`,
            },
        },
    };

    return (
        <div style={{ padding: '10px', border: '2px solid #e5e7eb', borderRadius: '8px' }}>
            <Chart options={options} series={series} type="bar" height={350} />
        </div>
    );
};

export default TestCaseTypeChart;
